import React from 'react'
import ReactDOM from 'react-dom/client'
import { App } from './App'
import { HashRouter } from 'react-router-dom'
import { ThemeProvider } from '@emotion/react'
import theme from './themes/Theme'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
   <React.StrictMode>
      <HashRouter>
         <ThemeProvider theme={theme}>
            <App />
         </ThemeProvider>
      </HashRouter>
   </React.StrictMode>
)
